// Copyright (c) 2025 Deere & Company

import RgaQandA, {getDefaultState as getRgaQuestionAnswerDetails} from '../state/rga-q-and-a';
import actions from '../../actions-list';

const setRgaQuestionAnswer = (state, action) =>
    RgaQandA.update(state, {
        $set: action.rgaDealerQuestionAns
    });

export default (state = getRgaQuestionAnswerDetails(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_Q_AND_A_DETAILS]: setRgaQuestionAnswer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-question-answer.js